import React from 'react';
import { useTranslation } from 'react-i18next';

function LanguageSwitcher() {
    const { i18n } = useTranslation();

    const handleLanguageChange = (event) => {
        i18n.changeLanguage(event.target.value);
    };

    return (
        <div className="relative inline-block">
            <select
                onChange={handleLanguageChange}
                value={i18n.language}
                className="appearance-none bg-gray-100 border border-gray-400 rounded-lg py-2 pl-4 pr-8 text-gray-800 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200 hover:border-gray-400 cursor-pointer shadow-sm text-s"
            >
                <option value="fr">Français</option>
                <option value="en">English</option>
            </select>
            {/* Icône flèche pour styliser le select */}
            <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                <svg
                    className="w-5 h-5 text-gray-800"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
            </div>
        </div>
    );
}

export default LanguageSwitcher;